<template>
  <div class="">
    <div v-for="(item, index) in fields" :key="index" class="horizontal-input-layout mt2">
      <span class="horizontal-input-label">
        <span :class="{b: isTemplateAlways(item)}">
          {{ item.name }}:
        </span>
      </span>
      <div class="horizontal-input-data flex flex-row">
        <input type="text" class="text-input bg-middle data-layout"
          :value="item.value"
          @input="updateItem(index, $event)"
        >
        <dropdown-button v-if="actions" :actions="actions"
          type='input-icon-button bg-middle text-secondary'
          @selected="$emit('action', { field: item, action: $event})">
          <font-awesome-icon icon="ellipsis-v" />
        </dropdown-button>
      </div>
      <span style="color: red" v-for="e in item.errors" v-bind:key="e" class="horizontal-input-error">{{e}}</span>
    </div>
  </div>
</template>

<script>
import DropdownButton from '@/components/ui/DropdownButton.vue'

function sortFields (fields, lodash) {
  // TODO: надо что-то придумать с разбиеним полей на группы...
  const groups = fields.reduce((acc, { name, value, settings }) => {
    const lowKey = lodash.toLower(name)
    if (lowKey.includes('орг.')) {
      acc.org.push({ name, value, settings })
    } else if (lowKey.includes('контр.')) {
      acc.countr.push({ name, value, settings })
    } else {
      acc.others.push({ name, value, settings })
    }
    return acc
  }, { org: [], countr: [], others: [] })
  return lodash.flatten([
    lodash.sortBy(groups.others, ({ name }) => name),
    lodash.sortBy(groups.org, ({ name }) => name),
    lodash.sortBy(groups.countr, ({ name }) => name)
  ])
}

export default {
  props: ['value', 'actions'],
  components: {
    DropdownButton
  },
  computed: {
    fields () {
      return sortFields(this.value || [], this.$lo)
    }
  },
  methods: {
    updateItem (index, event) {
      this.$emit('input', this.fields.map((curItem, curIndex) => {
        return index === curIndex
          ? { ...curItem, value: event.target.value }
          : curItem
      }))
    },
    /*
    updateSettings (index, action) {
      this.$emit('input', this.fields.map((curItem, curIndex) => {
        const settingsObj = Object.fromEntries(curItem.settings.map(item => [item.name, item.value]))

        const settings = Object
          .entries({ ...settingsObj, overridePolicy: action.code })
          .map(([key, value]) => ({ name: key, value }))

        return index === curIndex
          ? { ...curItem, settings }
          : curItem
      }))
    },
    */
    isTemplateAlways (item) {
      return item.settings?.find(i => i.name === 'overridePolicy')?.value === 'template_always'
    }
  },
  data () {
    return {
      error: false
    }
  }
}
</script>

<style>
.data-layout {
  display: grid;
  grid-template-columns: 3px 1fr;
  grid-template-rows: auto;
  align-items: center;
  min-height: 40px;
}
.template_always {
  font-weight: bold;
}
</style>
